import { render } from "./CaseDocuments.vue?vue&type=template&id=ecd32ca6&ts=true"
import script from "./CaseDocuments.vue?vue&type=script&lang=ts"
export * from "./CaseDocuments.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\TTI.AVE.Web\\Vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__